/**
 * SPJ-1372: helper condivisi per mostrare i campi distintivi dei progetti
 * (consegna, macrotema, linea, creatore) in WelcomePage e StorageModal.
 */

/**
 * Sigle per consegna/macrotema lunghi. Mappa esplicita per i casi noti, con fallback
 * che tiene il testo se corto o lo tronca (il testo intero resta nel tooltip `title`).
 */
export const ABBREVIATION_MAP: Record<string, string> = {
  'spring/resort': 'S/R',
  'spring resort': 'S/R',
  'highsummer': 'HS',
  'high summer': 'HS',
  'rtw': 'RTW',
  'clubwear': 'CW',
  'pre-spring': 'PS',
  'pre spring': 'PS',
  'pre-fall': 'PF',
  'pre fall': 'PF',
  'cruise': 'CR',
};

const MAX_INLINE_LENGTH = 10;

export function abbreviate(value?: string | null): { label: string; title?: string } {
  const text = (value ?? '').trim();
  if (!text) {
    return { label: '' };
  }
  const mapped = ABBREVIATION_MAP[text.toLowerCase()];
  if (mapped) {
    return { label: mapped, title: text };
  }
  if (text.length <= MAX_INLINE_LENGTH) {
    return { label: text };
  }
  return { label: `${text.slice(0, MAX_INLINE_LENGTH - 1)}…`, title: text };
}

/** Valori distinti (trimmed, non vuoti) ordinati, per popolare i filtri select. */
export function distinctValues(values: Array<string | undefined>): string[] {
  const set = new Set<string>();
  for (const value of values) {
    const trimmed = value?.trim();
    if (trimmed) {
      set.add(trimmed);
    }
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}
